//CompareMaps.tsx ==============================================================
import "../Util/Prototypes";

import * as CompareMaps from "../Widgets/CompareMaps";
import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Util_MUI from "../Util/Util_MUI";

import { Button, Icon, IconButton, Paper, Popover, Slider, Table, TableBody, TableCell, TableRow, TextField, Typography } from "@mui/material";

import Collection from "@arcgis/core/core/Collection.js";

import React from "react";

export let reloadBasemaps: boolean = true;
//Setters.
export function setReloadBasemaps(reload: boolean) {
   reloadBasemaps = reload;
}

let swipeFudge: number = 0.001; //To force swipe refresh.
let popoverActive: boolean = false;
let compareThemeNameLeft: string;
let compareThemeNameRight: string;
let compareThemeNames: string[];
let originalIDs: string[];
let originalsVisible: boolean[];
let swipeWidget: __esri.Swipe;
let sliderValueLeft: number;
let sliderValueRight: number;
let sliderMoved: boolean = false;
let basemapNameLeft: string;
let basemapNameRight: string;
let currentBasemapName: string;
let basemapLayers: __esri.Layer[];
let basemapNames: string[];

//Load compare theme dropdown names.
function loadCompareThemeNames() {
   if (!compareThemeNames) {
      compareThemeNames = [];

      let leftIndex: number = Settings.compareThemes.length - 1;
      let rightIndex: number = 0;
      let i: number = 0;

      for (const compareTheme of Settings.compareThemes) {
         compareThemeNames.Add(compareTheme.name);

         if (compareTheme.name === Settings.startupLeftTheme) {
            leftIndex = i;
         } else if (compareTheme.name === Settings.startupRightTheme) {
            rightIndex = i;
         }
         i++;
      }
      compareThemeNameLeft = compareThemeNames[leftIndex];
      compareThemeNameRight = compareThemeNames[rightIndex];
   }
}

//Load basemap names for sliders.
function loadBasemapNames() {
   if (CompareMaps.reloadBasemaps) {
      reloadBasemaps = false;
      basemapNames = [];

      for (const bm of MainMap.basemaps) {
         basemapNames.InsertAt(0, bm.id);
      }

      basemapNameLeft = basemapNames[0];
      basemapNameRight = basemapNames[basemapNames.length - 1];

      sliderValueLeft = 0;
      sliderValueRight = basemapNames.length - 1;
   }
}

//Save original layer visibility.
function saveOriginalLayerVisibility() {
   originalIDs = [];
   originalsVisible = [];

   for (let i: number = 0; i < MainMap.map.allLayers.length; i++) {
      const layer = MainMap.map.allLayers.getItemAt(i);
      if (layer.type !== "graphics") {
         originalIDs.Add(layer.id);
         originalsVisible.Add(layer.visible);
         //Util.errMsg("Save original Layer: " + layer.id);
      }
   }
}

//Restore original layer visibility.
function restoreOriginalLayerVisibility() {
   for (let i: number = 0; i < originalIDs.length; i++) {
      const layer = Util_App.getLayerById(originalIDs[i]) as __esri.Layer;
      if (layer) {
         layer.visible = originalsVisible[i];
         //Util.errMsg("Restore original Layer: " + layer.id);
      }
   }
}

//Temporarily add unloaded basemaps to main map. (Excluding the active basemap)
function addBasemapsToOperational() {
   basemapLayers = [];

   for (const basemap of MainMap.basemaps) {
      const layer = basemap.baseLayers.getItemAt(0);

      //Don't add the current basemap to the operational layers.
      if (layer.id !== currentBasemapName) {
         layer.visible = false;
         MainMap.map.add(layer, 0);
      }
      basemapLayers.Add(layer);
   }
}

//Turn the basemaps off. (Excluding the active basemap)
function hideBasemaps() {
   for (const basemap of basemapLayers) {
      if (basemap.id !== currentBasemapName) {
         basemap.visible = false;
      }
   }
}

//Restore basemaps back on.
function restoreBasemaps() {
   for (const basemap of basemapLayers) {
      basemap.visible = true;
   }
}

//Build swipe tool.
function buildSwipe() {
   import("@arcgis/core/widgets/Swipe").then(({ default: Swipe }) => {
      //Util.logMsg("Top of buildSwipe");

      let compareTheme: Settings.iCompareTheme;
      let layers: __esri.Collection<__esri.Layer>;
      let pos: number;

      //Hide basemaps and restore original on/off layer status.
      hideBasemaps();
      restoreOriginalLayerVisibility();

      //Trailing layers. (Right side)
      let trailingLayers: __esri.Collection<__esri.Layer> = new Collection;

      compareTheme = getCompareSetting(compareThemeNameRight);

      layers = getLayers(compareTheme.layers);
      if (layers.length > 0) {
         trailingLayers = layers;
      }

      if (!sliderMoved) {
         pos = getBasemapPosition(compareTheme.layers);
         if (pos !== -1) {
            sliderValueRight = pos;
            basemapNameRight = basemapNames[pos];
         }
      }

      //Leading layers. (Left side)
      let leadingLayers: __esri.Collection<__esri.Layer> = new Collection;
      compareTheme = getCompareSetting(compareThemeNameLeft);

      layers = getLayers(compareTheme.layers);
      if (layers.length > 0) {
         leadingLayers = layers;
      }

      if (!sliderMoved) {
         pos = getBasemapPosition(compareTheme.layers);
         if (pos !== -1) {
            sliderValueLeft = pos;
            basemapNameLeft = basemapNames[pos];
         }
      }

      //Add basemaps.
      sliderMoved = false;
      let layer: __esri.Layer;

      layer = Util_App.getLayerById(basemapNameRight) as __esri.Layer;
      if (layer) {
         layer.visible = true;
         trailingLayers.push(layer);
      }
      //Util.errMsg("Trailing layers: ", trailingLayers);

      layer = Util_App.getLayerById(basemapNameLeft) as __esri.Layer;
      if (layer) {
         layer.visible = true;
         leadingLayers.push(layer);
      }
      //Util.errMsg("LeadingLayers layers: ", leadingLayers);

      //Build swipe widget.
      if (swipeWidget) {
         swipeWidget.leadingLayers = leadingLayers;
         swipeWidget.trailingLayers = trailingLayers;
         swipeWidget.position = swipeWidget.position + swipeFudge; //Refresh the widget hack.
         swipeFudge = -swipeFudge;

      } else {
         swipeWidget = new Swipe({
            leadingLayers: leadingLayers,
            trailingLayers: trailingLayers,
            position: 50, //Set position of widget to 50%
            visibleElements: { divider: true, handle: false },
            view: MainMap.activeView as __esri.MapView,
         });

         MainMap.activeView.ui.add(swipeWidget);

      }
   }).catch((error: Error) => {
      console.error('An error occurred while loading the Swipe Widget module:', error);
   });
}

//Get map theme layers.
function getLayers(compareThemeLayers: Settings.iCompareDetail[]): __esri.Collection<__esri.Layer> {
   const layers = new Collection<__esri.Layer>;

   for (const compareThemeLayer of compareThemeLayers) {
      const layerType: string = compareThemeLayer.layerType;

      if (layerType.toLowerCase() !== "basemap") {
         for (const layerName of compareThemeLayer.layerNames) {
            const layer = Util_App.getLayerById(layerName) as __esri.Layer;

            if (layer) {
               layer.visible = true;
               layers.add(layer);
            }
         }
      }
   }
   return layers;
}

//Get index position in settings of basemap.
function getBasemapPosition(compareThemeLayers: Settings.iCompareDetail[]): number {
   let pos: number = -1;

   for (const compareThemeLayer of compareThemeLayers) {
      const layerType: string = compareThemeLayer.layerType;
      if (layerType.toLowerCase() === "basemap") {
         pos = basemapNames.indexOf(compareThemeLayer.layerNames[0]);
      }
   }
   return pos;
}

//Get compare setting.
function getCompareSetting(compareThemeName: string): Settings.iCompareTheme {
   for (const compareTheme of Settings.compareThemes) {
      if (compareTheme.name === compareThemeName) {
         return compareTheme;
      }
   }
   return null;
}

//Close this tool.
export function clearTool() {
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of swipe Render");

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
      currentBasemapName = MainMap.map.basemap.id;
      loadCompareThemeNames();
      loadBasemapNames();
      saveOriginalLayerVisibility();
      addBasemapsToOperational();
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      Util.logMsg("Creating swipe widget");
      buildSwipe();

      //Open the choose maps popover.
      setTimeout(function () {
         const elem = document.getElementById("choose-maps-button");
         setAnchorEl(elem);
         popoverActive = true;
      }, 1000);

      //Component will unmount.
      return () => {
         hideBasemaps();
         restoreOriginalLayerVisibility();
         restoreBasemaps();

         if (basemapLayers && basemapLayers.length > 0) {
            for (const basemap of basemapLayers) {
               if (basemap.id !== currentBasemapName) {
                  MainMap.map.remove(basemap);
               }
            }
            basemapLayers = [];
         }

         MainMap.activeView.ui.remove(swipeWidget);
         swipeWidget.destroy();
         swipeWidget = null;
      };
   }, []);

   //Component did update.
   React.useEffect(() => {
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Compare theme changed.
   function compareThemeChanged(side: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      let compareTheme: Settings.iCompareTheme;
      let pos: number;

      if (side === "Left") {
         compareThemeNameLeft = event.target.value;
         compareTheme = getCompareSetting(compareThemeNameLeft);
         pos = getBasemapPosition(compareTheme.layers);
         if (pos !== -1) {
            sliderValueLeft = pos;
            basemapNameLeft = basemapNames[pos];
         }

      } else {
         compareThemeNameRight = event.target.value;
         compareTheme = getCompareSetting(compareThemeNameRight);
         pos = getBasemapPosition(compareTheme.layers);
         if (pos !== -1) {
            sliderValueRight = pos;
            basemapNameRight = basemapNames[pos];
         }
      }

      buildSwipe();
      refresh();
   }

   //Slider changed event.
   function sliderChanged(event: Event, sliderValue: number | number[], side: string) {
      let valueChanged: boolean = false;
      const value = sliderValue as number;

      if (side === "Left") {
         if (value !== sliderValueLeft) {
            valueChanged = true;
            sliderValueLeft = value;
            basemapNameLeft = basemapNames[value];
         }

      } else {
         if (value !== sliderValueRight) {
            valueChanged = true;
            sliderValueRight = value;
            basemapNameRight = basemapNames[value];
         }
      }

      if (valueChanged) {
         sliderMoved = true;
         buildSwipe();
         refresh();
      }
   }

   //Popover events.
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
   const open = Boolean(anchorEl);
   const popoverID = open ? 'compareMaps-popover' : undefined;

   function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorEl(event.currentTarget);
      popoverActive = true;
   }

   function handleClose() {
      setAnchorEl(null);
      popoverActive = false;
   }

   function mouseLeavePopover() {
      if (popoverActive) {
         handleClose();
      }
   }

   //Icons.
   const menuIcon = <Icon style={{ fontSize: 18 }}>more_vert</Icon>;

   //Styles.
   const styles: Default.iStyles = {
      button: { paddingLeft: 9, paddingRight: 9 },
      popoverContent: { margin: 9 },
      tableCell: { border: 0 },
      slider: { width: 180 },
   };

   return (
      <Paper>
         <div style={Default.styles.appToolHeading}>
            <Typography variant="body1" style={{ marginLeft: 12 }}>
               Compare
            </Typography>

            <Button id="choose-maps-button" style={styles.button} variant="outlined" color="info" onClick={handleClick} aria-describedby={popoverID} startIcon={menuIcon} title="Choose maps to compare" aria-label="Choose maps">
               Choose Maps
            </Button>

            <Popover
               id={popoverID}
               open={open}
               anchorEl={anchorEl}
               onClose={handleClose}
               anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
               }}
            >
               <div style={styles.popoverContent} onMouseLeave={mouseLeavePopover}>
                  <Table aria-label="Compare Menu">
                     <TableBody>
                        <TableRow>
                           <TableCell style={styles.tableCell} padding="none">

                              <TextField select style={{ width: 200 }}
                                 label="Left Map Theme"
                                 title="Compare maps theme left side"
                                 inputProps={{ id: "left-themes" }}
                                 InputLabelProps={{ htmlFor: "left-themes" }}
                                 value={compareThemeNameLeft}
                                 onChange={(event) => compareThemeChanged("Left", event)}
                              >
                                 {Util_MUI.buildSelectMenuItems(compareThemeNames)}
                              </TextField>

                           </TableCell>

                           <TableCell style={styles.tableCell} padding="none">

                              <TextField select style={{ width: 200, marginLeft: 15 }}
                                 label="Right Map Theme"
                                 title="Compare maps theme right side"
                                 inputProps={{ id: "right-themes" }}
                                 InputLabelProps={{ htmlFor: "right-themes" }}
                                 value={compareThemeNameRight}
                                 onChange={(event) => compareThemeChanged("Right", event)}
                              >
                                 {Util_MUI.buildSelectMenuItems(compareThemeNames)}
                              </TextField>

                           </TableCell>
                        </TableRow>

                        <TableRow>
                           <TableCell style={{ paddingTop: 20, border: 0 }} padding="none" align="center">
                              <Typography id="left-basemap" color="textSecondary" gutterBottom variant="body2">Left Basemap</Typography>
                           </TableCell>

                           <TableCell style={{ paddingTop: 20, border: 0 }} padding="none" align="center">
                              <Typography id="right-basemap" color="textSecondary" gutterBottom variant="body2">Right Basemap</Typography>
                           </TableCell>
                        </TableRow>

                        <TableRow>
                           <TableCell style={styles.tableCell} padding="none" align="center">
                              <Typography variant="body2">{basemapNameLeft}</Typography>
                           </TableCell>

                           <TableCell style={styles.tableCell} padding="none" align="center">
                              <Typography variant="body2">{basemapNameRight}</Typography>
                           </TableCell>
                        </TableRow>

                        <TableRow>
                           <TableCell style={styles.tableCell} padding="none" align="center">
                              <Slider style={styles.slider}
                                 value={sliderValueLeft}
                                 aria-labelledby="left-basemap"
                                 valueLabelDisplay="off"
                                 marks
                                 min={0}
                                 max={basemapNames.length - 1}
                                 step={1}
                                 onChange={(event, value) => sliderChanged(event, value, "Left")}
                              />
                           </TableCell>

                           <TableCell style={styles.tableCell} padding="none" align="center">
                              <Slider style={styles.slider}
                                 value={sliderValueRight}
                                 aria-labelledby="right-basemap"
                                 valueLabelDisplay="off"
                                 marks
                                 min={0}
                                 max={basemapNames.length - 1}
                                 step={1}
                                 onChange={(event, value) => sliderChanged(event, value, "Right")}
                              />
                           </TableCell>
                        </TableRow>

                     </TableBody>
                  </Table>
               </div>
            </Popover>

            <IconButton color="default" onClick={close} title="Close" aria-label="Close" >
               <Icon color="action">close</Icon>
            </IconButton>
         </div>
      </Paper>
   ); //end return.

} //end function.
